.loadingPopup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  transition: background-color 0.3s ease;
}

.loading {
  background-color: color-mix(in oklch, var(--background) 80%, transparent);
}

.generating {
  background-color: color-mix(in oklch, var(--brand-950) 50%, transparent);
}

.darkMode.loading {
  background-color: color-mix(in oklch, var(--brand-950) 80%, transparent);
  color: var(--foreground);
}

.darkMode.generating {
  background-color: color-mix(in oklch, var(--brand-950) 80%, transparent);
  color: var(--foreground);
}

.loading .loader,
.generating .loader,
.loading .loadingText,
.generating .loadingText {
  color: var(--foreground);
}

.darkMode .loader,
.darkMode .loadingText {
  color: var(--foreground);
}

.loadingContentBox {
  background-color: var(--card);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 75px;
  width: 200px;
  padding: 10px;
}

.loadingContent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  justify-content: left;
}

.loadingLeft {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: left;
}

.loadingRight {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: right;
}

.loadingText {
	font-size: 1rem;
	font-weight: 500;
	color: var(--foreground);
	white-space: nowrap;
}

.spinner {
  border: 4px solid var(--border);
  border-top: 4px solid var(--success);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* HTML: <div class="loader"></div> */
/* HTML: <div class="loader"></div> */

.loader {
  width: 40px;
  height: 40px;
  --c: no-repeat linear-gradient(var(--brand-dark-green) 0 0);
  background: var(--c), var(--c), var(--c), var(--c);
  background-size: 21px 21px;
  animation: l5 1.5s infinite cubic-bezier(0.3, 1, 0, 1);
}

.darkMode .loader {
  --c: no-repeat linear-gradient(var(--foreground) 0 0);
}

@keyframes l5 {
  0% {
    background-position:
      0 0,
      100% 0,
      100% 100%,
      0 100%;
  }
  33% {
    background-position:
      0 0,
      100% 0,
      100% 100%,
      0 100%;
    width: 60px;
    height: 60px;
  }
  66% {
    background-position:
      100% 0,
      100% 100%,
      0 100%,
      0 0;
    width: 60px;
    height: 60px;
  }
  100% {
    background-position:
      100% 0,
      100% 100%,
      0 100%,
      0 0;
  }
}
